import { addISOWeekYears } from "date-fns";
import {
  REQUEST_FAILED,
  REQUEST_GET_ORG_INFO_DATA,
  REFRESH_ORG_INFO_DATA,
  REQUEST_UPDATE_ORG_DATA,
  REFRESH_ORG_DATA,
  REQUEST_GET_ALL_MEMBERS_OF_ORG,
  REQUEST_ADD_MEMBER_TO_ORG,
  REQUEST_REMOVE_MEMBER_FROM_ORG,
  REFRESH_ORG_MEMBERS,
} from "../actions/organization";

import { LOG_OUT } from "../actions/user";

const defaultState = {
  orgId: -1,
  orgInfoData: {
    orgInfo: {},
    orgData: {},
    libAppId: -1,
  },
  members: [],
  orgChannels: [],
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case REQUEST_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
      });
    case REQUEST_GET_ORG_INFO_DATA:
      return Object.assign({}, state, {
        isLoading: true,
      });
    case REFRESH_ORG_INFO_DATA:
      let ocList = action.orgInfoData.orgChannels;
      let oi = action.orgInfoData;
      delete oi.orgChannels;
      return Object.assign({}, state, {
        isLoading: false,
        orgId: action.orgId,
        orgInfoData: oi,
        orgChannels: ocList,
      });
    case REQUEST_UPDATE_ORG_DATA:
      return Object.assign({}, state, {
        isLoading: true,
      });
    case REFRESH_ORG_DATA:
      return Object.assign({}, state, {
        isLoading: false,
        orgInfoData: {
          ...state.orgInfoData,
          orgData: action.orgData,
        },
      });
    case REQUEST_GET_ALL_MEMBERS_OF_ORG:
      return Object.assign({}, state, {
        isLoading: true,
      });
    case REQUEST_ADD_MEMBER_TO_ORG:
      return Object.assign({}, state, {
        isLoading: true,
      });
    case REQUEST_REMOVE_MEMBER_FROM_ORG:
      return Object.assign({}, state, {
        isLoading: true,
      });
    case REFRESH_ORG_MEMBERS:
      return Object.assign({}, state, {
        isLoading: false,
        members: action.members,
      });
    case LOG_OUT:
      return {
        orgId: -1,
        orgInfoData: {
          orgInfo: {},
          orgData: {},
          libAppId: -1,
          orgChannels: [],
        },
        members: [],
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/organization.js